import { render, staticRenderFns } from "./ActionAnswer.vue?vue&type=template&id=a6bf94e6&"
import script from "./ActionAnswer.vue?vue&type=script&lang=ts&"
export * from "./ActionAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports